/* Instant DTF Prints: shared helpers for the builder sections (Dawn theme) */
window.IDP = window.IDP || {};
const $ = (id) => document.getElementById(id);
let idpToastTimer;
function toast(msg) {
  let t = $('idp-toast');
  if (!t) { t = document.createElement('div'); t.id = 'idp-toast'; t.className = 'idp-toast'; document.body.appendChild(t); }
  t.textContent = msg; t.classList.add('on'); clearTimeout(idpToastTimer);
  idpToastTimer = setTimeout(() => t.classList.remove('on'), 2800);
}
IDP.money = (cents) => {
  const fmt = (window.IDP.moneyFormat || '${{amount}}');
  const amount = (cents / 100).toFixed(2);
  return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
};
/* Add one line to the cart. formData must contain id, quantity and any properties[...] (files allowed). */
IDP.cartAdd = async function (formData, opts) {
  opts = opts || {};
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && opts.render !== false) {
    formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
    formData.append('sections_url', window.location.pathname);
  }
  const res = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: formData });
  const json = await res.json();
  if (json.status) throw new Error(json.description || json.message || 'Could not add to cart');
  if (cart && opts.render !== false) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'idp-builder', cartData: json });
    cart.renderContents(json);
  }
  return json;
};
IDP.busy = (btn, on, label) => { if (!btn) return; btn.disabled = on; btn.classList.toggle('loading', on); if (label !== undefined) btn.querySelector('span').textContent = label; };
